import ArrowCategory from './ArrowCategory'
import CategoryButton from './CategoryButton'
import Comment from './Comment'
import Compare from './Compare'
import Heart from './Heart'
import HeartFull from './HeartFull'
import Eye from './Eye'
import Star from './Star'
import Status from './Status'
import Sold from './Sold'
import Delivery from './Delivery'
import ArrowsWhite from './ArrowsWhite'
import Instagram from './Instagram'
import Facebook from './Facebook'
import Youtube from './Youtube'
import Burger from './Burger'
import Errors from './Errors'
import CloseBurger from './CloseBurger'
import Cart from './Cart'
import ViewGrid2 from './ViewGrid2.vue'
import ViewGrid4 from './ViewGrid4.vue'
import ViewGrid9 from './ViewGrid9.vue'
import ViewGrid12 from './ViewGrid12.vue'
import HeartHeader from './HeartHeader'
import AccordionArrow from './AccordionArrow'
import Earth from './Earth'
import EarthMap from './EarthMap'
import Info from './Info'
import Search from './Search'
import Apps from './Apps'
import FilterAttr from './FilterAttr'
import Pen from './Pen'
import Home from './Home'
import Account from './Account'
import Close from './Close'
import Main from './Main'
import Art from './Art'
import Share from './Share'
import Brilliant from './Brilliant'
import Graph from './Graph'
import Marker from './Marker'
import Shield from './Shield'
import Money from './Money'
import LikeDown from './LikeDown'
import LikeUp from './LikeUp'
import Filter from './Filter'
import FilterView from './FilterView'
import Done from './Done'
import Phone from './Phone'
import Mail from './Mail'
import CartWhite from './CartWhite'
import Contact from './Contact'
import ContactV2 from './ContactV2'
import Fop from './Fop'
import StarGold from './StarGold'
import Percent from './Percent'
import Grade from './Grade'
import ArrowDeg from './ArrowDeg'
import Message from './Message'
import Book from './Book'
import CartSmall from './CartSmall'
import PlayRed from './PlayRed'
import FacebookV2 from './FacebookV2'
import Google from './Google'
import HomeActive from './HomeActive'
import Ok from './Ok'
import Chevron from './Chevron'
import InfoHelp from './InfoHelp'
import ImportImage from './ImportImage'
import Rotate from './Rotate'
import Scale from './Scale'
import CloseFilter from './CloseFilter'
import ArrowsGrey from './ArrowsGrey'
import CloseMenu from './CloseMenu'
import Delete from './Delete'
import CartMoney from './CartMoney'
import ChevronGrey from './ChevronGrey'
import Minus from './Minus'
import Plus from './Plus'
import Back from './Back'
import ShieldV2 from './ShieldV2'
import InfoV2 from './InfoV2'
import ClockV2 from './ClockV2'
import LikeComment from './LikeComment'
import AppsV2 from './AppsV2'
import StarYellow from './StarYellow'
import Switch from './Switch'
import CloseV2 from './CloseV2'
import FavoritePreviewBlack from './FavoritePreviewBlack'
import CompareBlack from './CompareBlack'
import Logout from './Logout'
import Free from './Free'
import EyeOpen from './EyeOpen'
import Success from './Success'
import Warning from './Warning'
import History from './History'
import GreyCart from './GreyCart'
import Chat from './Chat'
import Settings from './Settings'
import Download from './Download'
import WaitList from './WaitList'
import Remove from './Remove'
import Personal from './Personal'
import CodeChecker from './CodeChecker'
import AppsPlus from './AppsPlus'
import Exit from './Exit'
import StarBordered from './StarBordered'
import Diamont from './Diamont.vue'
import MessageNew from './MessageNew.vue'
import WarningNew from './WarningNew.vue'
import Check from './Check.vue'
import CheckDark from './CheckDark.vue'
import ArrowReturn from './ArrowReturn.vue'
import StarGrey from './StarGrey.vue'
import CartPlus from './CartPlus.vue'
import CloseRed from './CloseRed.vue'
import Pointer from './Pointer.vue'
import PlusNew from './PlusNew.vue'
import ChatList from './ChatList.vue'
import CartCheck from './CartCheck.vue'
import Author from './Author.vue'
import SendArrow from './SendArrow.vue'
import Add from './Add.vue'
import ChevronTriengle from './ChevronTriengle.vue'
import Language from './Language.vue'
import Error from './Error'
import Balance from './Balance'
import WaitListV2 from './WaitListV2'
import Import from './Import'
import ErrorShield from './ErrorShield'
import Cash from './Cash'
import Doc from './Doc'
import Pencil from './Pencil'
import DownloadV2 from './DownloadV2'
import File from './File'
import BurgerWhite from './BurgerWhite'
import Copy from './Copy'
import Whatsapp from './Whatsapp'
import Viber from './Viber'
import Telegram from './Telegram'
import Email from './Email'
import Date from './Date'
import Drafts from './Drafts'
import ChevronDark from './ChevronDark'
import Sale from './Sale'
import GoPage from './GoPage'
import Arhive from './Arhive'
import CopyV2 from './CopyV2'
import Sort from './Sort'
import EditCategory from './EditCategory'
import Uah from './Uah'
import ExitV2 from './ExitV2'
import SliderPrev from './SliderPrev'
import SliderNext from './SliderNext'
import Reload from './Reload'
import Play from './Play'
import Stop from './Stop'
import EditFiles from './EditFiles'
import UahV2 from './UahV2'
import Key from './Key'
import PenV2 from './PenV2'
import Arrow from './Arrow'
export default function install(Vue, prefix = 'UnIcon') {
  Vue.component(`${prefix}Reload`, Reload)
  Vue.component(`${prefix}ViewGrid4`, ViewGrid4)
  Vue.component(`${prefix}ViewGrid2`, ViewGrid2)
  Vue.component(`${prefix}HomeActive`, HomeActive)
  Vue.component(`${prefix}ViewGrid9`, ViewGrid9)
  Vue.component(`${prefix}ViewGrid12`, ViewGrid12)
  Vue.component(`${prefix}UahV2`, UahV2)
  Vue.component(`${prefix}Key`, Key)
  Vue.component(`${prefix}PenV2`, PenV2)
  Vue.component(`${prefix}Arrow`, Arrow)
  Vue.component(`${prefix}EditFiles`, EditFiles)
  Vue.component(`${prefix}Play`, Play)
  Vue.component(`${prefix}Stop`, Stop)
  Vue.component(`${prefix}Viber`, Viber)
  Vue.component(`${prefix}Language`, Language)
  Vue.component(`${prefix}Whatsapp`, Whatsapp)
  Vue.component(`${prefix}Date`, Date)
  Vue.component(`${prefix}FilterAttr`, FilterAttr)
  Vue.component(`${prefix}GoPage`, GoPage)
  Vue.component(`${prefix}Arhive`, Arhive)
  Vue.component(`${prefix}EditCategory`, EditCategory)
  Vue.component(`${prefix}Uah`, Uah)
  Vue.component(`${prefix}ExitV2`, ExitV2)
  Vue.component(`${prefix}SliderPrev`, SliderPrev)
  Vue.component(`${prefix}SliderNext`, SliderNext)
  Vue.component(`${prefix}CopyV2`, CopyV2)
  Vue.component(`${prefix}Sort`, Sort)
  Vue.component(`${prefix}Sale`, Sale)
  Vue.component(`${prefix}Drafts`, Drafts)
  Vue.component(`${prefix}ChevronDark`, ChevronDark)
  Vue.component(`${prefix}WaitListV2`, WaitListV2)
  Vue.component(`${prefix}Email`, Email)
  Vue.component(`${prefix}Telegram`, Telegram)
  Vue.component(`${prefix}Import`, Import)
  Vue.component(`${prefix}Pencil`, Pencil)
  Vue.component(`${prefix}File`, File)
  Vue.component(`${prefix}Copy`, Copy)
  Vue.component(`${prefix}BurgerWhite`, BurgerWhite)
  Vue.component(`${prefix}DownloadV2`, DownloadV2)
  Vue.component(`${prefix}Cash`, Cash)
  Vue.component(`${prefix}Doc`, Doc)
  Vue.component(`${prefix}ErrorShield`, ErrorShield)
  Vue.component(`${prefix}Balance`, Balance)
  Vue.component(`${prefix}Error`, Error)
  Vue.component(`${prefix}ChevronTriengle`, ChevronTriengle)
  Vue.component(`${prefix}Add`, Add)
  Vue.component(`${prefix}SendArrow`, SendArrow)
  Vue.component(`${prefix}Author`, Author)
  Vue.component(`${prefix}CartCheck`, CartCheck)
  Vue.component(`${prefix}ChatList`, ChatList)
  Vue.component(`${prefix}PlusNew`, PlusNew)
  Vue.component(`${prefix}Pointer`, Pointer)
  Vue.component(`${prefix}CloseRed`, CloseRed)
  Vue.component(`${prefix}ArrowReturn`, ArrowReturn)
  Vue.component(`${prefix}StarGrey`, StarGrey)
  Vue.component(`${prefix}CartPlus`, CartPlus)
  Vue.component(`${prefix}Pen`, Pen)
  Vue.component(`${prefix}CheckDark`, CheckDark)
  Vue.component(`${prefix}Check`, Check)
  Vue.component(`${prefix}WarningNew`, WarningNew)
  Vue.component(`${prefix}MessageNew`, MessageNew)
  Vue.component(`${prefix}Diamont`, Diamont)
  Vue.component(`${prefix}Exit`, Exit)
  Vue.component(`${prefix}Logout`, Logout)
  Vue.component(`${prefix}Remove`, Remove)
  Vue.component(`${prefix}AppsPlus`, AppsPlus)
  Vue.component(`${prefix}Download`, Download)
  Vue.component(`${prefix}CodeChecker`, CodeChecker)
  Vue.component(`${prefix}Personal`, Personal)
  Vue.component(`${prefix}WaitList`, WaitList)
  Vue.component(`${prefix}Errors`, Errors)
  Vue.component(`${prefix}Free`, Free)
  Vue.component(`${prefix}EyeOpen`, EyeOpen)
  Vue.component(`${prefix}Warning`, Warning)
  Vue.component(`${prefix}History`, History)
  Vue.component(`${prefix}Chat`, Chat)
  Vue.component(`${prefix}Settings`, Settings)
  Vue.component(`${prefix}GreyCart`, GreyCart)
  Vue.component(`${prefix}Success`, Success)
  Vue.component(`${prefix}Eye`, Eye)
  Vue.component(`${prefix}CompareBlack`, CompareBlack)
  Vue.component(`${prefix}FavoritePreviewBlack`, FavoritePreviewBlack)
  Vue.component(`${prefix}ArrowCategory`, ArrowCategory)
  Vue.component(`${prefix}LikeComment`, LikeComment)
  Vue.component(`${prefix}CategoryButton`, CategoryButton)
  Vue.component(`${prefix}AppsV2`, AppsV2)
  Vue.component(`${prefix}StarYellow`, StarYellow)
  Vue.component(`${prefix}CloseV2`, CloseV2)
  Vue.component(`${prefix}Switch`, Switch)
  Vue.component(`${prefix}Comment`, Comment)
  Vue.component(`${prefix}InfoV2`, InfoV2)
  Vue.component(`${prefix}Compare`, Compare)
  Vue.component(`${prefix}Heart`, Heart)
  Vue.component(`${prefix}HeartFull`, HeartFull)
  Vue.component(`${prefix}Star`, Star)
  Vue.component(`${prefix}Status`, Status)
  Vue.component(`${prefix}ShieldV2`, ShieldV2)
  Vue.component(`${prefix}ClockV2`, ClockV2)
  Vue.component(`${prefix}Sold`, Sold)
  Vue.component(`${prefix}Delivery`, Delivery)
  Vue.component(`${prefix}ArrowsWhite`, ArrowsWhite)
  Vue.component(`${prefix}Instagram`, Instagram)
  Vue.component(`${prefix}Facebook`, Facebook)
  Vue.component(`${prefix}Youtube`, Youtube)
  Vue.component(`${prefix}Burger`, Burger)
  Vue.component(`${prefix}CloseBurger`, CloseBurger)
  Vue.component(`${prefix}Cart`, Cart)
  Vue.component(`${prefix}HeartHeader`, HeartHeader)
  Vue.component(`${prefix}AccordionArrow`, AccordionArrow)
  Vue.component(`${prefix}Info`, Info)
  Vue.component(`${prefix}Earth`, Earth)
  Vue.component(`${prefix}EarthMap`, EarthMap)
  Vue.component(`${prefix}Search`, Search)
  Vue.component(`${prefix}Apps`, Apps)
  Vue.component(`${prefix}Home`, Home)
  Vue.component(`${prefix}Account`, Account)
  Vue.component(`${prefix}Close`, Close)
  Vue.component(`${prefix}ContactV2`, ContactV2)
  Vue.component(`${prefix}Back`, Back)
  Vue.component(`${prefix}Main`, Main)
  Vue.component(`${prefix}Art`, Art)
  Vue.component(`${prefix}Share`, Share)
  Vue.component(`${prefix}Brilliant`, Brilliant)
  Vue.component(`${prefix}Graph`, Graph)
  Vue.component(`${prefix}Marker`, Marker)
  Vue.component(`${prefix}Shield`, Shield)
  Vue.component(`${prefix}Money`, Money)
  Vue.component(`${prefix}LikeDown`, LikeDown)
  Vue.component(`${prefix}LikeUp`, LikeUp)
  Vue.component(`${prefix}Filter`, Filter)
  Vue.component(`${prefix}FilterView`, FilterView)
  Vue.component(`${prefix}Done`, Done)
  Vue.component(`${prefix}Phone`, Phone)
  Vue.component(`${prefix}Mail`, Mail)
  Vue.component(`${prefix}Contact`, Contact)
  Vue.component(`${prefix}Fop`, Fop)
  Vue.component(`${prefix}StarGold`, StarGold)
  Vue.component(`${prefix}Percent`, Percent)
  Vue.component(`${prefix}Grade`, Grade)
  Vue.component(`${prefix}ArrowDeg`, ArrowDeg)
  Vue.component(`${prefix}Message`, Message)
  Vue.component(`${prefix}Book`, Book)
  Vue.component(`${prefix}CartSmall`, CartSmall)
  Vue.component(`${prefix}PlayRed`, PlayRed)
  Vue.component(`${prefix}FacebookV2`, FacebookV2)
  Vue.component(`${prefix}Google`, Google)
  Vue.component(`${prefix}Ok`, Ok)
  Vue.component(`${prefix}Chevron`, Chevron)
  Vue.component(`${prefix}InfoHelp`, InfoHelp)
  Vue.component(`${prefix}ImportImage`, ImportImage)
  Vue.component(`${prefix}Rotate`, Rotate)
  Vue.component(`${prefix}Scale`, Scale)
  Vue.component(`${prefix}CloseFilter`, CloseFilter)
  Vue.component(`${prefix}ArrowsGrey`, ArrowsGrey)
  Vue.component(`${prefix}CloseMenu`, CloseMenu)
  Vue.component(`${prefix}Delete`, Delete)
  Vue.component(`${prefix}CartMoney`, CartMoney)
  Vue.component(`${prefix}ChevronGrey`, ChevronGrey)
  Vue.component(`${prefix}Minus`, Minus)
  Vue.component(`${prefix}Plus`, Plus)
  Vue.component(`${prefix}CartWhite`, CartWhite)
  Vue.component(`${prefix}StarBordered`, StarBordered)
}
